<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
html,
 body {
   width: 100%;
   height: 100%;
   box-sizing: border-box;
   padding: 0px;
   margin: 0px;
 }
 ul{
  padding: 0;
  margin: 0;
  list-style: none;
 }
 #app {
   font-family: "Avenir", Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   color: #2c3e50;
   widows: 100%;
   height: 100%;
 }
 .fz14{
  font-size: 14px!important;
 }
 .mb20 {
   margin-bottom: 20px;
 }

 /* layout */
 .relative {
   position: relative;
 }

 .flex {
   display: flex;
 }

 .flex1 {
   flex: 1;
 }

 .flex-all {
   display: flex;
   align-items: center;
   justify-content: center;
 }

 .flex-andmid {
   display: flex;
   align-items: center;
 }
 .flex-sb {
   display: flex;
   align-items: center;
   justify-content: space-between;
 }

 .flex_column {
   flex-direction: column;
 }

 .flex_wrap {
   flex-wrap: wrap;
 }

 .flex_nowrap {
   flex-wrap: nowrap;
 }

 .flex_center {
   align-items: center;
 }

 .flex_start {
   align-items: flex-start;
 }

 .flex_end {
   align-items: flex-end;
 }

 .justify_center {
   justify-content: center;
 }

 .justify_end {
   justify-content: flex-end;
 }

 .justify_sa {
   justify-content: space-around;
 }

 .justify_sb {
   justify-content: space-between;
 }

 .flex_rowreverse {
   flex-direction: row-reverse;
 }

 .align_self_end {
   align-self: flex-end;
 }

 .align_self_center {
   align-self: center;
 }

 /* margin */


 /* font */
 .fontSize_14 {
   font-size: 14px;
 }

 .fontSize_18 {
   font-size: 18px;
 }

 .fontSize_16 {
   font-size: 16px;
 }

 .fontSize_20 {
   font-size: 20px;
 }

 .fontSize_24 {
   font-size: 16px;
 }

 .fontSize_30 {
   font-size: 26px;
 }

 .fontSize_36 {
   font-size: 32px;
 }

 .fontSize_40 {
   font-size: 36px;
 }

 .bold {
   font-weight: bold;
 }

 /* tetxt */
 .text_center {
   text-align: center;
 }

 .borderR {
   border-right: 1px solid #EBEEF5;
 }
 
.avatar {
  border: 1px solid #666;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
.el-upload__tip {
  margin-left: 20px;
}


.border{
  border: 1px solid #EBEEF5;
}
.flex-1 {
  flex: 1;
}
.w30vw {
  width: 20vw;
}
.w8vw {
  width: 10vw;
}
.flex {
  display: flex;
}
.alignCenter {
  align-content: center;
}
.between {
  justify-content: space-between;
}
.p20 {
  padding: 20px;
}
.lineHeight {
  line-height: 2;
}
.lineHeight1 {
  line-height: 1.6;
}
.text-blue {
  color: #403DE3;
}
.text-gray {
  color: rgb(146, 146, 146);
}


.text-red{
  color: #ED592B;
}
.text-center {
  text-align: center;
}
.borderBottom {
  border-bottom: 1px solid #EBEEF5;
}
.borderRight {
  border-right: 1px solid #EBEEF5;
}
.text-left{
  text-align: left;
}
.marginBottom{
  margin-bottom: 20px;
}

.marginRight {
  margin-right: 12px;
}
.mflex .el-message-box__content {
  display: flex;
  align-content: center;
}
.mflex .el-message-box__input {
  padding-top: 0;
  margin-left: 10px;
}
.backgroundGray{
  background: #eee;
}
.pointer{
  cursor:pointer
}
</style>



// WEBPACK FOOTER //
// src/App.vue